export default __webpack_public_path__ + "static/media/calculator_icon_light_mode.143a50d6.svg";